import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueResize from 'vue-resize'
import VueMeta from 'vue-meta'
import App from './App'
import router from './router'
import { sync } from 'vuex-router-sync'
import store from '@/store/store'
import i18n from '@/i18n/i18n'
import 'vue-material-design-icons/styles.css'
import config from '@/config/default'

Vue.use(VueCookies)
Vue.use(VueResize)
Vue.use(VueMeta)

const moment = require('moment')
require('moment/locale/en-gb')
require('moment/locale/ru')
require('moment/locale/az')

let locale = VueCookies.get('locale') || i18n.locale
if (!i18n.messages[locale]) {
  locale = i18n.locale
}
i18n.locale = locale
VueCookies.set('locale', locale)

moment.locale(locale === 'en' ? 'en-gb' : locale)
Vue.use(require('vue-moment'), { moment })

Vue.directive('phone', {
  bind (el) {
    el.oninput = function (e) {
      if (!e.isTrusted) {
        return
      }

      const x = this.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/)
      this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
      el.dispatchEvent(new Event('input'))
    }
  }
})

Vue.directive('firstname', {
  bind (el) {
    el.oninput = function (e) {
      if (!e.isTrusted) {
        return
      }
      this.value = this.value.replace(/[^A-Za-z]/g, '')
      this.value = this.value.toUpperCase()
      el.dispatchEvent(new Event('input'))
    }
  }
})

Vue.directive('lastname', {
  bind (el) {
    el.oninput = function (e) {
      if (!e.isTrusted) {
        return
      }
      this.value = this.value.replace(/[^A-Za-z]/g, '')
      this.value = this.value.toUpperCase()
      el.dispatchEvent(new Event('input'))
    }
  }
})

Vue.directive('promo', {
  bind (el) {
    el.oninput = function (e) {
      if (!e.isTrusted) {
        return
      }
      this.value = this.value.toUpperCase()
      el.dispatchEvent(new Event('input'))
    }
  }
})

Vue.directive('fin', {
  bind (el) {
    el.oninput = function (e) {
      if (!e.isTrusted) {
        return
      }

      if (Number(this.value.length) > 7) {
        this.value = this.value.substr(0, 7)
      }

      this.value = this.value.toUpperCase()
      el.dispatchEvent(new Event('input'))
    }
  }
})

Vue.use({
  install: function (Vue, options) {
    Vue.prototype.config = config
    Vue.prototype.isActive = function (property, value) {
      return this.$route.matched.some(record => record.meta[property] === value)
    }
  }
})

Vue.config.productionTip = false

sync(store, router)

const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})

export default app



// WEBPACK FOOTER //
// ./src/main.js